(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/dialog/dist/mdc.dialog.js"), require("@material/dom/dist/mdc.dom.js"), require("@material/react-button/dist/index.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/dialog/dist/mdc.dialog.js", "@material/dom/dist/mdc.dom.js", "@material/react-button/dist/index.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/dialog/dist/mdc.dialog.js"), require("@material/dom/dist/mdc.dom.js"), require("@material/react-button/dist/index.js")) : factory(root["react"], root["classnames"], root["@material/dialog/dist/mdc.dialog.js"], root["@material/dom/dist/mdc.dom.js"], root["@material/react-button/dist/index.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_34__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 27);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },,
    /* 2 */

    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN

      var BASE = 'mdc-dialog';
      var cssClasses = {
        BASE: BASE,
        CONTAINER: BASE + "__container",
        SURFACE: BASE + "__surface",
        TITLE: BASE + "__title",
        CONTENT: BASE + "__content",
        ACTIONS: BASE + "__actions",
        BUTTON: BASE + "__button",
        DEFAULT_BUTTON: BASE + "__button--default",
        SCRIM: BASE + "__scrim"
      };
      exports.cssClasses = cssClasses;
      var LAYOUT_EVENTS = ['resize', 'orientationchange'];
      exports.LAYOUT_EVENTS = LAYOUT_EVENTS;
      /***/
    },,,,,,,,,,,,,,,,,,,,,,,,
    /* 4 */

    /* 5 */

    /* 6 */

    /* 7 */

    /* 8 */

    /* 9 */

    /* 10 */

    /* 11 */

    /* 12 */

    /* 13 */

    /* 14 */

    /* 15 */

    /* 16 */

    /* 17 */

    /* 18 */

    /* 19 */

    /* 20 */

    /* 21 */

    /* 22 */

    /* 23 */

    /* 24 */

    /* 25 */

    /* 26 */

    /* 27 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var __extends = this && this.__extends || function () {
        var _extendStatics = function extendStatics(d, b) {
          _extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return _extendStatics(d, b);
        };

        return function (d, b) {
          _extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1); // @ts-ignore no .d.ts file


      var mdc_dialog_1 = __webpack_require__(28); // @ts-ignore no .d.ts file


      var mdc_dom_1 = __webpack_require__(29);
      /* eslint-disable no-unused-vars */


      var DialogContent_1 = __webpack_require__(30);

      exports.DialogContent = DialogContent_1.default;

      var DialogFooter_1 = __webpack_require__(31);

      exports.DialogFooter = DialogFooter_1.default;

      var DialogTitle_1 = __webpack_require__(32);

      exports.DialogTitle = DialogTitle_1.default;
      /* eslint-enable no-unused-vars */

      var DialogButton_1 = __webpack_require__(33);

      exports.DialogButton = DialogButton_1.default;

      var constants_1 = __webpack_require__(3);

      ;

      function isDialogTitle(element) {
        return element.type === DialogTitle_1.default;
      }

      function isDialogContent(element) {
        return element.type === DialogContent_1.default;
      }

      var Dialog =
      /** @class */
      function (_super) {
        __extends(Dialog, _super);

        function Dialog() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.dialogElement = React.createRef();
          _this.state = {
            classList: new Set()
          };

          _this.open = function () {
            // focusTrap will not initialize if no children present.
            _this.initializeFocusTrap();

            _this.foundation.open();
          };

          _this.initializeFocusTrap = function () {
            _this.focusTrap = _this.props.children && mdc_dialog_1.util.createFocusTrapInstance(_this.dialogElement.current);
          };

          _this.handleOpening = function () {
            _this.props.onOpening();

            constants_1.LAYOUT_EVENTS.forEach(function (evt) {
              return window.addEventListener(evt, _this.handleLayout);
            });
            document.addEventListener('keydown', _this.handleDocumentKeyDown);
          };

          _this.handleClosing = function (action) {
            _this.props.onClosing(action);

            constants_1.LAYOUT_EVENTS.forEach(function (evt) {
              return window.removeEventListener(evt, _this.handleLayout);
            });
            document.removeEventListener('keydown', _this.handleDocumentKeyDown);
          };

          _this.handleInteraction = function (e) {
            return _this.foundation.handleInteraction(e);
          };

          _this.handleDocumentKeyDown = function (e) {
            return _this.foundation.handleDocumentKeydown(e);
          };

          _this.handleLayout = function () {
            return _this.foundation.layout();
          };

          _this.renderContainer = function (children) {
            return !children ? undefined : React.createElement("div", {
              className: constants_1.cssClasses.CONTAINER
            }, React.createElement("div", {
              className: constants_1.cssClasses.SURFACE
            }, React.Children.map(children, _this.renderChild)));
          };

          _this.renderChild = function (child, i) {
            return isDialogTitle(child) || isDialogContent(child) ? React.cloneElement(child, __assign({
              key: "child-" + i
            }, child.props, {
              id: _this.setId(child, child.props.id)
            })) : child;
          };

          _this.setId = function (child, componentId) {
            var id = _this.props.id;

            if (isDialogTitle(child)) {
              var labelledBy = componentId || id + '-title';
              _this.labelledBy = labelledBy;
              return labelledBy;
            }

            var describedBy = componentId || id + '-content';
            _this.describedBy = describedBy;
            return describedBy;
          };

          return _this;
        }

        Dialog.prototype.componentDidMount = function () {
          var _a = this.props,
              open = _a.open,
              autoStackButtons = _a.autoStackButtons,
              escapeKeyAction = _a.escapeKeyAction,
              scrimClickAction = _a.scrimClickAction;
          this.foundation = new mdc_dialog_1.MDCDialogFoundation(this.adapter);
          this.foundation.init();

          if (open) {
            this.open();
          }

          if (!autoStackButtons) {
            this.foundation.setAutoStackButtons(autoStackButtons);
          }

          if (typeof escapeKeyAction === 'string') {
            // set even if empty string
            this.foundation.setEscapeKeyAction(escapeKeyAction);
          }

          if (typeof scrimClickAction === 'string') {
            // set even if empty string
            this.foundation.setScrimClickAction(scrimClickAction);
          }
        };

        Dialog.prototype.componentWillUnmount = function () {
          this.foundation.destroy();
        };

        Dialog.prototype.componentDidUpdate = function (prevProps) {
          var _a = this.props,
              open = _a.open,
              autoStackButtons = _a.autoStackButtons,
              escapeKeyAction = _a.escapeKeyAction,
              scrimClickAction = _a.scrimClickAction;

          if (prevProps.autoStackButtons !== autoStackButtons) {
            this.foundation.setAutoStackButtons(autoStackButtons);
          }

          if (prevProps.escapeKeyAction !== escapeKeyAction) {
            this.foundation.setEscapeKeyAction(escapeKeyAction);
          }

          if (prevProps.scrimClickAction !== scrimClickAction) {
            this.foundation.setScrimClickAction(scrimClickAction);
          }

          if (prevProps.open !== open) {
            return open ? this.open() : this.foundation.close();
          }
        };

        Object.defineProperty(Dialog.prototype, "classes", {
          get: function get() {
            var classList = this.state.classList;
            var className = this.props.className;
            return classnames_1.default(constants_1.cssClasses.BASE, Array.from(classList), className);
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(Dialog.prototype, "buttons", {
          get: function get() {
            var buttons = this.dialogElement.current && [].slice.call(this.dialogElement.current.getElementsByClassName(constants_1.cssClasses.BUTTON));
            return buttons ? buttons : [];
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(Dialog.prototype, "content", {
          get: function get() {
            return this.dialogElement.current && this.dialogElement.current.querySelector("." + constants_1.cssClasses.CONTENT);
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(Dialog.prototype, "defaultButton", {
          get: function get() {
            return this.dialogElement.current && this.dialogElement.current.querySelector("." + constants_1.cssClasses.DEFAULT_BUTTON);
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(Dialog.prototype, "adapter", {
          get: function get() {
            var _this = this;

            var strings = mdc_dialog_1.MDCDialogFoundation.strings;
            var closest = mdc_dom_1.ponyfill.closest,
                matches = mdc_dom_1.ponyfill.matches;
            var isScrollable = mdc_dialog_1.util.isScrollable,
                areTopsMisaligned = mdc_dialog_1.util.areTopsMisaligned;
            return {
              addClass: function addClass(className) {
                var classList = _this.state.classList;
                classList.add(className);

                _this.setState({
                  classList: classList
                });
              },
              removeClass: function removeClass(className) {
                var classList = _this.state.classList;
                classList.delete(className);

                _this.setState({
                  classList: classList
                });
              },
              hasClass: function hasClass(className) {
                return _this.classes.split(' ').includes(className);
              },
              addBodyClass: function addBodyClass(className) {
                return document.body.classList.add(className);
              },
              removeBodyClass: function removeBodyClass(className) {
                return document.body.classList.remove(className);
              },
              eventTargetMatches: function eventTargetMatches(target, selector) {
                return matches(target, selector);
              },
              trapFocus: function trapFocus() {
                return _this.focusTrap && _this.focusTrap.activate();
              },
              releaseFocus: function releaseFocus() {
                return _this.focusTrap && _this.focusTrap.deactivate();
              },
              isContentScrollable: function isContentScrollable() {
                var content = _this.content;
                return !!content ? isScrollable(content) : false;
              },
              areButtonsStacked: function areButtonsStacked() {
                var buttons = _this.buttons;
                return !!buttons ? areTopsMisaligned(_this.buttons) : false;
              },
              getActionFromEvent: function getActionFromEvent(evt) {
                var elem = closest(evt.target, "[" + strings.ACTION_ATTRIBUTE + "]");
                return elem && elem.getAttribute(strings.ACTION_ATTRIBUTE);
              },
              clickDefaultButton: function clickDefaultButton() {
                var defaultButton = _this.defaultButton;

                if (defaultButton) {
                  defaultButton.click();
                }
              },
              reverseButtons: function reverseButtons() {
                var buttons = _this.buttons;
                return buttons && buttons.reverse().forEach(function (button) {
                  return button.parentElement && button.parentElement.appendChild(button);
                });
              },
              notifyOpening: function notifyOpening() {
                return _this.handleOpening();
              },
              notifyOpened: function notifyOpened() {
                return _this.props.onOpen && _this.props.onOpen();
              },
              notifyClosing: function notifyClosing(action) {
                return _this.handleClosing(action);
              },
              notifyClosed: function notifyClosed(action) {
                return _this.props.onClose && _this.props.onClose(action);
              }
            };
          },
          enumerable: true,
          configurable: true
        });

        Dialog.prototype.render = function () {
          var _a = this.props,

          /* eslint-disable no-unused-vars */
          autoStackButtons = _a.autoStackButtons,
              className = _a.className,
              children = _a.children,
              escapeKeyAction = _a.escapeKeyAction,
              id = _a.id,
              onOpening = _a.onOpening,
              onOpen = _a.onOpen,
              onClick = _a.onClick,
              onClosing = _a.onClosing,
              onClose = _a.onClose,
              onKeyDown = _a.onKeyDown,
              open = _a.open,
              scrimClickAction = _a.scrimClickAction,
              Tag = _a.tag,
              otherProps = __rest(_a, ["autoStackButtons", "className", "children", "escapeKeyAction", "id", "onOpening", "onOpen", "onClick", "onClosing", "onClose", "onKeyDown", "open", "scrimClickAction", "tag"])
          /* eslint-enable no-unused-vars */
          ;

          var container = this.renderContainer(children);
          return (// @ts-ignore Tag does not have any construct https://github.com/Microsoft/TypeScript/issues/28892
            React.createElement(Tag, __assign({}, otherProps, {
              "aria-labelledby": this.labelledBy,
              "aria-describedby": this.describedBy,
              "aria-modal": true,
              className: this.classes,
              id: id,
              onKeyDown: this.handleInteraction,
              onClick: this.handleInteraction,
              ref: this.dialogElement
            }), container, React.createElement("div", {
              className: constants_1.cssClasses.SCRIM
            }))
          );
        };

        Dialog.defaultProps = {
          autoStackButtons: true,
          className: '',
          onOpening: function onOpening() {},
          onClosing: function onClosing() {},
          tag: 'div',
          id: 'mdc-dialog',
          open: false,
          role: 'alertdialog'
        };
        return Dialog;
      }(React.Component);

      exports.default = Dialog;
      /***/
    },
    /* 28 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_28__;
      /***/
    },
    /* 29 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_29__;
      /***/
    },
    /* 30 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1);

      var constants_1 = __webpack_require__(3);

      ;

      var DialogContent = function DialogContent(_a) {
        var
        /* eslint-disable react/prop-types */
        _b = _a.className,

        /* eslint-disable react/prop-types */
        className = _b === void 0 ? '' : _b,
            children = _a.children,
            _c = _a.tag,
            Tag = _c === void 0 ? 'div' : _c,
            otherProps = __rest(_a, ["className", "children", "tag"])
        /* eslint-enable react/prop-types */
        ;

        return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
          React.createElement(Tag, __assign({
            className: classnames_1.default(className, constants_1.cssClasses.CONTENT)
          }, otherProps), children)
        );
      };

      exports.default = DialogContent;
      /***/
    },
    /* 31 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1);

      var constants_1 = __webpack_require__(3);

      ;

      var DialogFooter = function DialogFooter(_a) {
        var
        /* eslint-disable react/prop-types */
        _b = _a.className,

        /* eslint-disable react/prop-types */
        className = _b === void 0 ? '' : _b,
            children = _a.children,
            _c = _a.tag,
            Tag = _c === void 0 ? 'footer' : _c,
            otherProps = __rest(_a, ["className", "children", "tag"])
        /* eslint-enable react/prop-types */
        ;

        return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
          React.createElement(Tag, __assign({
            className: classnames_1.default(className, constants_1.cssClasses.ACTIONS)
          }, otherProps), children)
        );
      };

      exports.default = DialogFooter;
      /***/
    },
    /* 32 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1);

      var constants_1 = __webpack_require__(3);

      ;

      var DialogTitle = function DialogTitle(_a) {
        var
        /* eslint-disable react/prop-types */
        _b = _a.className,

        /* eslint-disable react/prop-types */
        className = _b === void 0 ? '' : _b,
            children = _a.children,
            _c = _a.tag,
            Tag = _c === void 0 ? 'h2' : _c,
            otherProps = __rest(_a, ["className", "children", "tag"])
        /* eslint-enable react/prop-types */
        ;

        return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
          React.createElement(Tag, __assign({
            className: classnames_1.default(className, constants_1.cssClasses.TITLE)
          }, otherProps), children)
        );
      };

      exports.default = DialogTitle;
      /***/
    },
    /* 33 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2019 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1);

      var constants_1 = __webpack_require__(3);

      var react_button_1 = __webpack_require__(34);

      ;

      var DialogButton = function DialogButton(_a) {
        var
        /* eslint-disable react/prop-types */
        action = _a.action,
            _b = _a.className,
            className = _b === void 0 ? '' : _b,
            children = _a.children,
            _c = _a.isDefault,
            isDefault = _c === void 0 ? false : _c,
            otherProps = __rest(_a, ["action", "className", "children", "isDefault"])
        /* eslint-enable react/prop-types */
        ;

        var _d;

        return (// @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
          React.createElement(react_button_1.default, __assign({
            className: classnames_1.default(className, constants_1.cssClasses.BUTTON, (_d = {}, _d[constants_1.cssClasses.DEFAULT_BUTTON] = isDefault, _d)),
            "data-mdc-dialog-action": action
          }, otherProps), children)
        );
      };

      exports.default = DialogButton;
      /***/
    },
    /* 34 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_34__;
      /***/
    }])
  );
});